import { render, staticRenderFns } from "./v80o1020AftPop.vue?vue&type=template&id=5cc160c0&scoped=true"
import script from "./v80o1020AftPop.vue?vue&type=script&lang=js"
export * from "./v80o1020AftPop.vue?vue&type=script&lang=js"
import style0 from "./v80o1020AftPop.vue?vue&type=style&index=0&id=5cc160c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc160c0",
  null
  
)

export default component.exports